module.exports = __webpack_public_path__ + "images/Settings.ba26b42869328200700f465822ac19a7.svg";